import axios from 'axios';
import get from 'lodash.get';

const baseUrl = '/automationRule';
const fetchAutomationRulesUrl = `${baseUrl}/rules`;
const reorderAutomationRulesUrl = `${baseUrl}/reorder`;
const reprocessAutomationRulesUrl = `${baseUrl}/reprocess`;
const ruleActionTypesUrl = `${baseUrl}/getRuleActionTypes`;
const suggestRuleUrl = `${baseUrl}/suggest`;
const addRuleUrl = `${baseUrl}/add`;
const updateRuleUrl = `${baseUrl}/update`;

export const fetchAutomationRules = async () => {
  try {
    const response = await axios.get(fetchAutomationRulesUrl);
    return get(response, 'data') || [];
  } catch (error) {
    throw new Error(`Error fetching automation rules: ${error?.message}`);
  }
};

export const reorderAutomationRules = async (rules = []) => {
  try {
    const response = await axios.post(reorderAutomationRulesUrl, rules);
    return get(response, 'data') || [];
  } catch (error) {
    throw new Error(`Error reordering automation rules: ${error?.message}`);
  }
};

export const deleteRule = async (ruleId) => {
  try {
    await axios.delete(`${baseUrl}/${ruleId}`);
  } catch (error) {
    throw new Error(`Error deleting automation rule ${ruleId}: ${error?.message}`);
  }
};

export const reprocessRules = async () => {
  try {
    const response = await axios.get(reprocessAutomationRulesUrl);
    return get(response, 'data') || '';
  } catch (error) {
    throw new Error(`Error processing automation rules: ${error?.message}`);
  }
};

export const getRuleActionTypes = async () => {
  try {
    const response = await axios.get(ruleActionTypesUrl);
    return get(response, 'data') || [];
  } catch (error) {
    throw new Error(`Error fetching automation rule types: ${error?.message}`);
  }
};

export const suggestRule = async (requestBody) => {
  try {
    const response = await axios.post(suggestRuleUrl, requestBody);
    const ruleData = response?.data || {};

    return ruleData;
  } catch (error) {
    throw new Error(`Error suggesting automation rule: ${error?.message}`);
  }
};

export const addRule = async (rule) => {
  const response = await axios.post(addRuleUrl, rule);
  return response;
};

export const updateRule = async (rule) => {
  const response = await axios.put(updateRuleUrl, rule);
  return response;
};
